<template>
  <div class="myGoogleMap">
    <div v-if="loading" class="centered_container">
      <LoadingCard></LoadingCard>
    </div>
    <gmap-map
      v-if="!loading"
      :center="center"
      :options="mapOptions"
      style="width:100%;  height: 90vh;"
    >
      <gmap-info-window
        class="mapWindow"
        :options="infoOptions"
        :position="infoPosition"
        :opened="infoOpened"
        @closeclick="infoOpened = false"
      >
        <h4>{{ infoCty }}</h4>
        <hr />
        <div :key="key" v-for="(item, key) in cityNum">
          <span>{{ item.data[0].addr }}</span>
          <br />
          <span>{{ item.data[0].addrs }}</span>

          <b-button
            size="sm"
            variant="primary btn-block mt-2 mb-2"
            @click="openData(item.data[0].id, infoCty, thisLat, thisLng)"
            >Location Data</b-button
          >
          <hr />
        </div>
      </gmap-info-window>
      <gmap-marker
        v-for="(m, index) in table"
        :key="index"
        :ref="`marker${index}`"
        :position="getPosition(m)"
        @click="toggleInfo(m, index)"
      ></gmap-marker>
    </gmap-map>
  </div>
</template>

<script>
import router from "../../../router";
import GmapCustomMarker from "vue2-gmap-custom-marker";
import LoadingCard from "../../../components/shared/LoadingCard.vue";

export default {
  name: "MapOverview",
  components: {
    router,
    GmapCustomMarker,
    LoadingCard
  },
  data() {
    return {
      // default to Montreal to keep it simple
      // change this to whatever makes sense
      loading: true,
      mapOptions: {
        zoom: 5,
        streetViewControl: false,
        mapTypeControl: false
      },
      center: { lat: 41.881832, lng: -87.6254 },
      table: [],
      stateDateFrom: "",
      markerOptions: {
        url: "/img/reddot.png",
        size: { width: 20, height: 20, f: "px", b: "px" },
        scaledSize: { width: 20, height: 20, f: "px", b: "px" }
      },
      stateDateTo: "",
      cityNum: null,
      thisLat: null,
      thisLng: null,
      infoPosition: null,
      infoCty: null,
      infoMny: null,
      infoCompany: null,
      infoPicture: null,
      infoOpened: false,
      infoQty: null,
      infoCurrentKey: null,

      infoOptions: {
        pixelOffset: {
          width: 0,
          height: -35
        }
      }
    };
  },

  mounted() {
    this.stateDateFrom = "2021-01-01";
    this.stateDateTo = new Date().toJSON().slice(0, 10);
    this.fetchMarkers();
  },
  // iz nekog razloga pri lokaciji moram dodati %282%29 da bi ucitalo, nisam siguran sto?
  methods: {
    openData(loc, city, lat, lng) {
      router.push(
        "/base/city/?loc=" +
          loc +
          "&city=" +
          city +
          "&lat=" +
          lat +
          "&lng=" +
          lng
      );
    },
    fetchMarkers() {
      this.loadingState = true;
      let params = {};
      params = {
        date_from: this.stateDateFrom,
        date_to: this.stateDateTo
      };
      this.$http
        .get("api/teleste/maps/mapPreview.php", {
          params
        })
        .then(
          res => {
            this.table = res.data.records;
            this.loading = false;
          },
          err => {
            console.log(err);
            this.loading = false;
          }
        );
    },
    getPosition: function(marker) {
      return {
        lat: parseFloat(marker[4]),
        lng: parseFloat(marker[5])
      };
    },

    toggleInfo: function(marker, key) {
      var result = { city: [] };
      var jsonObj;

      this.table.forEach(value => {
        if (marker[0] == value[0]) {
          jsonObj = {
            data: [
              {
                id: value[1],
                addr: value[2],
                addrs: value[3]
              }
            ]
          };
          result.city.push(jsonObj);
        }
      });
      this.infoPosition = this.getPosition(marker);
      this.infoCty = marker[0];
      this.cityNum = result.city;
      this.infoQty = marker[2];
      this.infoMny = marker[3];
      this.thisLat = marker[4];
      this.thisLng = marker[5];

      if (this.infoCurrentKey === key) {
        this.infoOpened = !this.infoOpened;
      } else {
        this.infoOpened = true;
        this.infoCurrentKey = key;
      }
    }
  }
};
</script>
<style scoped>
.myGoogleMap {
  margin-top: -17px !important;
  margin-right: -30px;
  margin-left: -30px;
}
</style>
<style>
.gm-style .gm-style-iw-d {
  color: black !important;
}
.gm-style .gm-style-iw-d span {
  font-size: 1.1em;
}
.gm-style .gm-style-iw-d b {
  font-size: 1.1em;
}
.centered_container {
  width: 100%;
  display: flex;
  justify-content: center;
}
</style>
